import Modal from "@hg/modal"
import cls from "classnames"
import React, { FC, useLayoutEffect, useRef, useState } from "react"

import { sfx } from "@/assets/audios/sfx"
import { Close } from "@/components/Close"
// import OutlinedText from "@/components/OutlinedText"
import { i18n } from "@/i18n"

import styles from "./index.module.scss"

const RuleContent: FC<{ onClose: () => void }> = ({ onClose }) => {
    const containerRef = useRef<HTMLDivElement>(null)
    const [isAtBottom, setIsAtBottom] = useState(false)

    useLayoutEffect(() => {
        const container = containerRef.current
        if (!container) {
            // 如果容器还没有准备好，使用 requestAnimationFrame 延迟检查
            const rafId = requestAnimationFrame(() => {
                const delayedContainer = containerRef.current
                if (delayedContainer) {
                    const handleScroll = () => {
                        const { scrollTop, scrollHeight, clientHeight } =
                            delayedContainer
                        // 判断是否滚动到底部（允许 1px 的误差）
                        const atBottom =
                            scrollHeight - scrollTop - clientHeight <= 1
                        setIsAtBottom(atBottom)
                    }

                    delayedContainer.addEventListener("scroll", handleScroll)
                    // 初始检查
                    handleScroll()
                }
            })

            return () => {
                cancelAnimationFrame(rafId)
            }
        }

        const handleScroll = () => {
            const { scrollTop, scrollHeight, clientHeight } = container
            // 判断是否滚动到底部（允许 1px 的误差）
            const atBottom = scrollHeight - scrollTop - clientHeight <= 1
            setIsAtBottom(atBottom)
        }

        container.addEventListener("scroll", handleScroll)
        // 初始检查
        handleScroll()

        return () => {
            container.removeEventListener("scroll", handleScroll)
        }
    }, [])

    return (
        <div className={styles.ruleModal}>
            <div
                ref={containerRef}
                className={cls(styles.ruleContainer, {
                    [styles.noMask]: isAtBottom,
                })}
            >
                <div className={styles.textContainer}>
                    {i18n
                        .getArray("rule.rules", "recall")
                        .map((item, index) => {
                            return (
                                <div
                                    key={item}
                                    className={styles.timeText}
                                    // biome-ignore lint/security/noDangerouslySetInnerHtml: i18n content
                                    dangerouslySetInnerHTML={{
                                        __html: item,
                                    }}
                                ></div>
                            )
                        })}
                    <div className={styles.section}>
                        {i18n.getRecall("rule.title_special_instructions")}
                    </div>
                    {i18n
                        .getArray("rule.special_instructions", "recall")
                        .map((item, index) => {
                            return (
                                <div className={styles.ruleItem} key={item}>
                                    <div className={styles.label}>
                                        0{index + 1}
                                    </div>
                                    <div
                                        className={styles.text}
                                        // biome-ignore lint/security/noDangerouslySetInnerHtml: i18n content
                                        dangerouslySetInnerHTML={{
                                            __html: item,
                                        }}
                                    ></div>
                                </div>
                            )
                        })}
                    <div className={styles.section}>
                        {i18n.getRecall("rule.title_attention")}
                    </div>
                    {i18n
                        .getArray("rule.attention", "recall")
                        .map((item, index) => {
                            return (
                                <div className={styles.ruleItem} key={item}>
                                    <div className={styles.label}>
                                        0{index + 1}
                                    </div>
                                    <div
                                        className={styles.text}
                                        // biome-ignore lint/security/noDangerouslySetInnerHtml: i18n content
                                        dangerouslySetInnerHTML={{
                                            __html: item,
                                        }}
                                    ></div>
                                </div>
                            )
                        })}
                    <div className={styles.section}>
                        {i18n.getRecall("rule.title_remind")}
                    </div>
                    {i18n
                        .getArray("rule.remind", "recall")
                        .map((item, index) => {
                            return (
                                <div className={styles.ruleItem} key={item}>
                                    <div className={styles.label}>
                                        0{index + 1}
                                    </div>
                                    <div
                                        className={styles.text}
                                        // biome-ignore lint/security/noDangerouslySetInnerHtml: i18n content
                                        dangerouslySetInnerHTML={{
                                            __html: item,
                                        }}
                                    ></div>
                                </div>
                            )
                        })}
                </div>
                <div className={styles.filter}></div>
            </div>
            <Close
                onClose={(e) => {
                    e.stopPropagation()
                    onClose()
                }}
            />
        </div>
    )
}

export const showRuleModal = () => {
    return Modal.show(
        ({ onClose }) => {
            return <RuleContent onClose={onClose} />
        },
        { maskClassName: "modal-mask" },
    )
}
